/* eslint-disable eqeqeq */
import DeviceDetector from 'device-detector-js';

export default {
  methods: {
    validDevice() {
      const deviceDetector = new DeviceDetector();
      const userAgent = navigator.userAgent;
      const currentDevice = deviceDetector.parse(userAgent);
      if (currentDevice.device == undefined || currentDevice.os == undefined) {
        return false;
      }
      if (
        currentDevice.device != undefined &&
        (currentDevice.device.model == undefined ||
          currentDevice.device.model == '') &&
        (currentDevice.device.brand == undefined ||
          currentDevice.device.brand == '' ||
          currentDevice.device.brand == 'Huawei')
      ) {
        return false;
      }
      if (
        currentDevice.os != undefined &&
        (currentDevice.os.name == undefined || currentDevice.os.name == '')
      ) {
        return false;
      }
      let isValidDevice = true;
      if (
        (currentDevice.device.brand &&
          currentDevice.device.brand === 'Apple') ||
        (currentDevice.os &&
          currentDevice.os.name &&
          currentDevice.device.name === 'iOS')
      ) {
        isValidDevice = this.validIos(currentDevice);
      } else if (
        currentDevice.device.brand &&
        currentDevice.device.brand === 'Huawei'
      ) {
        isValidDevice = !this.notValidHuawei(currentDevice.device);
      } else if (currentDevice.os && currentDevice.os.name === 'Android') {
        isValidDevice = this.validAndroid(currentDevice.os);
      }
      return isValidDevice;
    },
    validIos(device) {
      const iosVersion = device.os.version.substr(
        0,
        device.os.version.indexOf('.'),
      );
      return iosVersion > 11;
    },
    validAndroid(deviceOs) {
      const androidVersion = deviceOs.version.toString();
      if (androidVersion.indexOf('.') != -1) {
        androidVersion.substr(0, androidVersion.indexOf('.'));
        return androidVersion >= 5;
      }
      return androidVersion >= 5;
      // return androidVersion > 21;
    },
    isIOSUserWithNotSafari() {
      const deviceDetector = new DeviceDetector();
      const userAgent = navigator.userAgent;
      const currentDevice = deviceDetector.parse(userAgent);
      if (
        currentDevice.os &&
        currentDevice.os.name.includes('iOS') &&
        currentDevice.client &&
        currentDevice.client.name.includes('Chrome')
      ) {
        return true;
      }
      return false;
    },
    notValidHuawei(device) {
      const filteredTypes = [];
      this.huaweiTypes.forEach(x =>
        filteredTypes.push(x.toLowerCase().replace(/ /g, '')),
      );
      const filteredOtherDeviceNames = [];

      Object.values(this.otherDeviceNames).forEach((x) => {
        x.forEach(name =>
          filteredOtherDeviceNames.push(name.toLowerCase().replace(/ /g, '')),
        );
      });

      const deviceModel = device.model
        .toString()
        .toLowerCase()
        .replace(/ /g, '');
      const mergedDeviceNames = filteredTypes.concat(filteredOtherDeviceNames);
      return !!mergedDeviceNames.find(
        x => x.includes(deviceModel) || deviceModel.includes(x),
      );
    }
  },
  computed: {
    huaweiTypes() {
      return [
        'p40 pro',
        'p40 pro plus',
        'mate 30',
        'mate 30 pro',
        'mate 30 pro 5g',
        'nova 6 se',
        'mate nova 7i',
        'nova 7 se 5g',
        'nova 7 5g',
        'nova 7 pro 5g',
        'y7p',
        'mate xs',
        'matepad pro 5g',
        'matepad 10.4',
        'matepad t8',
        'p40lite',
        'enjoy 10e',
        'y5p',
        'y6p',
        'y8p',
        'honor 30',
        'honor 30 pro',
        'honor 30 pro plus',
        'honor x10 5g',
        'honor 8a prime',
        'honor 9c',
        'honor 9a',
        'honor 9s',
        'honor 4t',
        'honor 4t pro',
        'honor play 9a',
        'honor 30s',
        'honor 9x pro',
        'honor 9x lite',
        'honor v30',
        'honor v30 pro',
        'honor v6'
      ];
    },
    otherDeviceNames() {
      return {
        p40: ['ANA-LNX9', 'ANA-LX4', 'ANA-NX9', 'ANA-L04'],
        P40Pro: ['ELS-NX9', 'ELS-N04'],
        P40ProPlus: ['ELS-N04'],
        mate30: ['TAS-AL00', 'TAS-TL00'],
        matenova7i: ['P40 Lite'],
        Nova7SE: ['JNY-LX1'],
        Nova7SE5G: ['cdy-tn20'],
        nova75g: ['jef-n30'],
        nova7pro5g: ['JER-AN10'],
        y7p: ['ART-L28', 'ART-L29', 'Y7 PRIME', 'Y7 Pro', 'Y7 ELITE', 'Y7 2'],
        matexs: ['MATE 30 PRO'],
        matepadpro5g: ['LYA-AL00', 'Mate 20 Pro'],
        matepad104: ['MatePad 10.4'],
        matepadt8: ['KOB2-L09', 'MediaPad T 8'],
        p40lite: ['p40', 'P40 Lite'],
        enjoy10e: ['Enjoy 10E'],
        y5p: ['Y5 PRIME', 'Y5 Pro', 'Y5 ELITE', 'Y5 2', 'DRA-LX9'],
        y6p: ['Y6 PRIME', 'Y6 Pro', 'Y6 ELITE', 'Y6 2'],
        y8p: ['Y8 PRIME', 'Y8 Pro', 'Y8 ELITE', 'Y8 2'],
        honor30: ['BMH-TN10'],
        honor30Pro: ['EBG-AN00'],
        honor30ProPlus: ['EBG-AN10'],
        honorX105g: ['TEL-TN00'],
        honorplay4Pro: ['OXP-AN00', 'OXF-AN00L'],
        honor8APrime: ['JAT-LX1'],
        honor9C: ['AKA-L29'],
        honor9A: ['MOA-LX9N'],
        honor9S: ['DUA-LX9'],
        honor4T: ['AKA-AL10', 'Honor Play 4T'],
        honor4TPro: ['AQM-AL10'],
        honorPlay9A: ['MOA-AL20'],
        honor30s: ['CDY-AN90'],
        honor9XLite: ['JSN-L21', 'JSN-L22', 'JSN-L23'],
        honor9XPro: ['Honor 9X'],
        honorV30: ['OXF-AN00'],
        honorV30Pro: ['Honor View 30 Pro'],
        honorv6: ['KRJ-W09', 'honorpadv6']
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/shared/mixins/ValidMobileDeviceMixin.js